<template>
  <div class="component-block">
    <div class="spin" v-if="loading">
      <LoadingSpinner/>
    </div>
    <NavigationView/>
    <div class="block-container">
      <div class="tableview-block">
        <div class="tableview-top">
          <div class="tableview-top-left">
            <div class="tableview-top-count">
              Все пользователи {{ startLoading ? '' : `(${tableItems.length})` }}
            </div>
            <div class="tableview-top-search pc">
              <label>
                <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                      fill="#4D5460"/>
                </svg>
                <input v-model="searchValue" type="text" placeholder="Найти пользователя...">
                <button
                    @click="this.searchValue = ''"
                    v-if="searchValue !== ''"
                    class="tableview-top-search-close">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
                  </svg>
                </button>
              </label>
            </div>
          </div>
          <div>
            <button @click="showCreateDialog" class="button-add-transparent pc">
              Добавить пользователя
            </button>
            <button @click="clearFilters" class="clear-filters pc">
              Сбросить фильтры
            </button>
            <button @click="showCreateDialog" class="button-add-transparent mobile">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 11H13V0H11V11H0V13H11V24H13V13H24V11Z"/>
              </svg>
            </button>
            <button @click="clearFilters" class="clear-filters mobile">
              <svg x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512"
                   xml:space="preserve" class="">
                <g>
                  <path
                      d="M19 13a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 19 13zm2.75 0A4.756 4.756 0 0 1 17 17.75a4.689 4.689 0 0 1-2.25-.593V21a.75.75 0 0 1-1.2.6l-4-3a.75.75 0 0 1-.3-.6v-4a.745.745 0 0 0-.221-.53L3.91 8.35a2.231 2.231 0 0 1-.66-1.59V4.5A2.253 2.253 0 0 1 5.5 2.25h13a2.253 2.253 0 0 1 2.25 2.25v2.26a2.235 2.235 0 0 1-.66 1.591l-.615.614A4.738 4.738 0 0 1 21.75 13zm-8.5 6.5v-3.619a4.7 4.7 0 0 1-1-2.881A4.756 4.756 0 0 1 17 8.25a4.692 4.692 0 0 1 .969.1l1.06-1.061a.745.745 0 0 0 .221-.53V4.5a.751.751 0 0 0-.75-.75h-13a.751.751 0 0 0-.75.75v2.26a.745.745 0 0 0 .221.53l5.119 5.12a2.231 2.231 0 0 1 .66 1.59v3.625zm7-6.5A3.25 3.25 0 1 0 17 16.25 3.254 3.254 0 0 0 20.25 13z"
                      opacity="1" data-original="#000000" class="">
                  </path>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="tableview-top-search mobile">
          <label>
            <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                  fill="#4D5460"/>
            </svg>
            <input v-model="searchValue" type="text" placeholder="Найти пользователя...">
            <button
                @click="this.searchValue = ''"
                v-if="searchValue !== ''"
                class="tableview-top-search-close">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
              </svg>
            </button>
          </label>
        </div>
        <div
            v-if="!startLoading"
            class="tableview-main"
        >
          <div
              class="tableview-main-left"
              :class="{ 'not-selected': itemsSelected.length === 0 }"
          >
            <EasyDataTable
                v-model:items-selected="itemsSelected"
                buttons-pagination
                :headers="tableHeaders"
                :items="tableItems"
                :search-value="searchValue"
                rows-of-page-separator-message="из"
                theme-color="#005291"
                table-class-name="customize-table"
                @click-row="selectUser"
                :filter-options="filterOptions"
            >
              <template #item-status="item">
                <div class="status-point-container">
                  <div class="status-point"
                       :class="{ 'inactive': item.status === 'ia' }"
                  ></div>
                </div>
                <div class="selected-field"
                     :class="{ 'selected': item.id === selectedUser.id }"
                ></div>
              </template>
              <template #empty-message>
                Данные не найдены
              </template>
              <!-- status filter-->
              <template #header-status="header">
                <div
                    class="filter-column"
                    :class="{ 'selected': statusCriteria !== 'Все' }"
                >
                  <button class="filter-icon"
                          @click.stop="showStatusFilter=!showStatusFilter;showCarrierFilter = false;showRoleFilter = false;">
                    <FilterIcon v-if="statusCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="statusCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showStatusFilter">
                    <Multiselect
                        v-model="statusCriteria"
                        :canDeselect="false"
                        :options="[
                      {'value':'Все', 'label': 'Все'},
                      {'value':'a', 'label': 'Активный'},
                      {'value':'ia', 'label': 'Неактивный'},
                  ]"
                    />
                  </div>
                </div>
              </template>
              <!-- carrier filter-->
              <template #header-carrierName="header">
                <div
                    class="filter-column"
                    :class="{ 'selected': carrierCriteria !== 'Все' }"
                >
                  <button class="filter-icon"
                          @click.stop="showCarrierFilter=!showCarrierFilter;showStatusFilter = false;showRoleFilter = false;">
                    <FilterIcon v-if="carrierCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="carrierCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showCarrierFilter">
                    <Multiselect
                        v-model="carrierCriteria"
                        :searchable="true"
                        :canDeselect="false"
                        :options="['Все', 'Цементум', ...multiselectItems.map(item => item.label)]"
                    />
                  </div>
                </div>
              </template>
              <!-- role filter-->
              <template #header-roleName="header">
                <div
                    class="filter-column"
                    :class="{ 'selected': roleCriteria !== 'Все' }"
                >
                  <button class="filter-icon"
                          @click.stop="showRoleFilter=!showRoleFilter;showStatusFilter = false;showCarrierFilter = false;">
                    <FilterIcon v-if="roleCriteria === 'Все'"/>
                    <FilterSelectedIcon v-if="roleCriteria !== 'Все'"/>
                  </button>
                  {{ header.text }}
                  <div @click.stop class="filter-menu" v-if="showRoleFilter">
                    <Multiselect
                        v-model="roleCriteria"
                        :searchable="true"
                        :canDeselect="false"
                        :options="['Все', 'Диспетчер', 'Администратор']"
                    />
                  </div>
                </div>
              </template>
            </EasyDataTable>
            <div class="tableview-main-selected" v-if="itemsSelected.length > 0">
              <div class="tableview-main-selected-left">
                Выбрано: {{ itemsSelected.length }}
              </div>
              <div class="tableview-main-selected-actions">
                <div class="tableview-main-selected-actions-text">
                  Действия с выбранными:
                </div>
<!--                <button class="download-btn">-->
<!--                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g clip-path="url(#clip0_1_1594)">-->
<!--                      <path-->
<!--                          d="M16.1218 17.4451C16.1948 17.5268 16.2509 17.6221 16.287 17.7255C16.3231 17.8289 16.3385 17.9385 16.3322 18.0478C16.326 18.1572 16.2982 18.2642 16.2505 18.3629C16.2028 18.4615 16.1362 18.5497 16.0543 18.6226L14.7327 19.8009C14.5062 20.0251 14.2377 20.2023 13.9425 20.3223C13.6473 20.4422 13.3313 20.5027 13.0127 20.5001C12.6822 20.5007 12.3549 20.4361 12.0494 20.31C11.744 20.1839 11.4664 19.9987 11.2327 19.7651L9.94601 18.6201C9.86426 18.5473 9.79764 18.4591 9.74997 18.3606C9.70229 18.2621 9.67449 18.1552 9.66814 18.0459C9.65533 17.8252 9.7307 17.6085 9.87767 17.4434C10.0246 17.2783 10.2312 17.1784 10.4519 17.1655C10.5611 17.1592 10.6706 17.1744 10.7739 17.2104C10.8773 17.2463 10.9726 17.3023 11.0543 17.3751L12.1668 18.3701V12.1667C12.1668 11.9457 12.2546 11.7338 12.4109 11.5775C12.5672 11.4212 12.7792 11.3334 13.0002 11.3334C13.2212 11.3334 13.4331 11.4212 13.5894 11.5775C13.7457 11.7338 13.8335 11.9457 13.8335 12.1667V18.3709L14.946 17.3776C15.1109 17.2307 15.3274 17.1554 15.5479 17.168C15.7684 17.1807 15.9748 17.2803 16.1218 17.4451V17.4451ZM15.7968 6.63424C15.6538 6.5898 15.5239 6.5106 15.4189 6.40372C15.3139 6.29683 15.237 6.16559 15.1952 6.02174C14.7539 4.60514 13.8527 3.37623 12.6343 2.52958C11.4158 1.68293 9.94978 1.26694 8.46825 1.34748C6.98672 1.42802 5.57439 2.00048 4.4549 2.97422C3.33542 3.94796 2.57275 5.26733 2.28767 6.7234C1.99516 8.19591 2.23122 9.72441 2.95434 11.0401C2.11138 11.4753 1.42593 12.1636 0.99427 13.0084C0.562611 13.8532 0.406433 14.812 0.547673 15.7501C0.764882 16.8399 1.34835 17.8227 2.20119 18.5351C3.05402 19.2476 4.12491 19.6469 5.23601 19.6667H7.16684C7.38785 19.6667 7.59981 19.5789 7.75609 19.4227C7.91237 19.2664 8.00017 19.0544 8.00017 18.8334C8.00017 18.6124 7.91237 18.4004 7.75609 18.2441C7.59981 18.0879 7.38785 18.0001 7.16684 18.0001H5.23601C4.5243 17.9864 3.83784 17.734 3.28683 17.2833C2.73582 16.8327 2.35224 16.2099 2.19767 15.5151C2.10718 14.918 2.20592 14.3077 2.48003 13.7696C2.75413 13.2316 3.18985 12.7929 3.72601 12.5151C4.10817 12.3039 4.39178 11.9507 4.51546 11.5319C4.63913 11.1131 4.59293 10.6625 4.38684 10.2776C4.06326 9.66045 3.87225 8.9825 3.82605 8.28722C3.77986 7.59195 3.87949 6.89469 4.11858 6.24018C4.35766 5.58567 4.73091 4.98836 5.21438 4.48656C5.69785 3.98476 6.28086 3.58956 6.92603 3.3263C7.57119 3.06305 8.26426 2.93755 8.96078 2.95785C9.65729 2.97816 10.3419 3.14383 10.9706 3.44423C11.5993 3.74463 12.1583 4.17314 12.6117 4.70225C13.0652 5.23136 13.403 5.84941 13.6035 6.51674C13.7268 6.91899 13.9466 7.28504 14.2436 7.58305C14.5405 7.88107 14.9058 8.10203 15.3077 8.22674C16.3963 8.55798 17.3384 9.25231 17.9771 10.194C18.6158 11.1357 18.9125 12.2678 18.8177 13.4017C18.7549 14.2834 18.4328 15.1269 17.8918 15.8259C17.7571 16.0012 17.6976 16.2228 17.7262 16.442C17.7549 16.6611 17.8695 16.8599 18.0448 16.9947C18.22 17.1294 18.4416 17.1889 18.6608 17.1603C18.88 17.1316 19.0788 17.017 19.2135 16.8417C19.9477 15.8845 20.3878 14.7345 20.4802 13.5317C20.606 12.0198 20.2098 10.5104 19.3576 9.25526C18.5053 8.0001 17.2486 7.07501 15.7968 6.63424V6.63424Z"-->
<!--                          fill="#374957"/>-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_1_1594">-->
<!--                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                  <span class="pc">Скачать в Excel</span>-->
<!--                  <span class="mobile">Excel</span>-->
<!--                </button>-->
<!--                <button class="download-btn">-->
<!--                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g clip-path="url(#clip0_1_1594)">-->
<!--                      <path-->
<!--                          d="M16.1218 17.4451C16.1948 17.5268 16.2509 17.6221 16.287 17.7255C16.3231 17.8289 16.3385 17.9385 16.3322 18.0478C16.326 18.1572 16.2982 18.2642 16.2505 18.3629C16.2028 18.4615 16.1362 18.5497 16.0543 18.6226L14.7327 19.8009C14.5062 20.0251 14.2377 20.2023 13.9425 20.3223C13.6473 20.4422 13.3313 20.5027 13.0127 20.5001C12.6822 20.5007 12.3549 20.4361 12.0494 20.31C11.744 20.1839 11.4664 19.9987 11.2327 19.7651L9.94601 18.6201C9.86426 18.5473 9.79764 18.4591 9.74997 18.3606C9.70229 18.2621 9.67449 18.1552 9.66814 18.0459C9.65533 17.8252 9.7307 17.6085 9.87767 17.4434C10.0246 17.2783 10.2312 17.1784 10.4519 17.1655C10.5611 17.1592 10.6706 17.1744 10.7739 17.2104C10.8773 17.2463 10.9726 17.3023 11.0543 17.3751L12.1668 18.3701V12.1667C12.1668 11.9457 12.2546 11.7338 12.4109 11.5775C12.5672 11.4212 12.7792 11.3334 13.0002 11.3334C13.2212 11.3334 13.4331 11.4212 13.5894 11.5775C13.7457 11.7338 13.8335 11.9457 13.8335 12.1667V18.3709L14.946 17.3776C15.1109 17.2307 15.3274 17.1554 15.5479 17.168C15.7684 17.1807 15.9748 17.2803 16.1218 17.4451V17.4451ZM15.7968 6.63424C15.6538 6.5898 15.5239 6.5106 15.4189 6.40372C15.3139 6.29683 15.237 6.16559 15.1952 6.02174C14.7539 4.60514 13.8527 3.37623 12.6343 2.52958C11.4158 1.68293 9.94978 1.26694 8.46825 1.34748C6.98672 1.42802 5.57439 2.00048 4.4549 2.97422C3.33542 3.94796 2.57275 5.26733 2.28767 6.7234C1.99516 8.19591 2.23122 9.72441 2.95434 11.0401C2.11138 11.4753 1.42593 12.1636 0.99427 13.0084C0.562611 13.8532 0.406433 14.812 0.547673 15.7501C0.764882 16.8399 1.34835 17.8227 2.20119 18.5351C3.05402 19.2476 4.12491 19.6469 5.23601 19.6667H7.16684C7.38785 19.6667 7.59981 19.5789 7.75609 19.4227C7.91237 19.2664 8.00017 19.0544 8.00017 18.8334C8.00017 18.6124 7.91237 18.4004 7.75609 18.2441C7.59981 18.0879 7.38785 18.0001 7.16684 18.0001H5.23601C4.5243 17.9864 3.83784 17.734 3.28683 17.2833C2.73582 16.8327 2.35224 16.2099 2.19767 15.5151C2.10718 14.918 2.20592 14.3077 2.48003 13.7696C2.75413 13.2316 3.18985 12.7929 3.72601 12.5151C4.10817 12.3039 4.39178 11.9507 4.51546 11.5319C4.63913 11.1131 4.59293 10.6625 4.38684 10.2776C4.06326 9.66045 3.87225 8.9825 3.82605 8.28722C3.77986 7.59195 3.87949 6.89469 4.11858 6.24018C4.35766 5.58567 4.73091 4.98836 5.21438 4.48656C5.69785 3.98476 6.28086 3.58956 6.92603 3.3263C7.57119 3.06305 8.26426 2.93755 8.96078 2.95785C9.65729 2.97816 10.3419 3.14383 10.9706 3.44423C11.5993 3.74463 12.1583 4.17314 12.6117 4.70225C13.0652 5.23136 13.403 5.84941 13.6035 6.51674C13.7268 6.91899 13.9466 7.28504 14.2436 7.58305C14.5405 7.88107 14.9058 8.10203 15.3077 8.22674C16.3963 8.55798 17.3384 9.25231 17.9771 10.194C18.6158 11.1357 18.9125 12.2678 18.8177 13.4017C18.7549 14.2834 18.4328 15.1269 17.8918 15.8259C17.7571 16.0012 17.6976 16.2228 17.7262 16.442C17.7549 16.6611 17.8695 16.8599 18.0448 16.9947C18.22 17.1294 18.4416 17.1889 18.6608 17.1603C18.88 17.1316 19.0788 17.017 19.2135 16.8417C19.9477 15.8845 20.3878 14.7345 20.4802 13.5317C20.606 12.0198 20.2098 10.5104 19.3576 9.25526C18.5053 8.0001 17.2486 7.07501 15.7968 6.63424V6.63424Z"-->
<!--                          fill="#374957"/>-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_1_1594">-->
<!--                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                  <span class="pc">Скачать в PDF</span>-->
<!--                  <span class="mobile">PDF</span>-->
<!--                </button>-->
                <button @click="deleteMultiple" class="delete-selected-btn">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_1597)">
                      <path
                          d="M18.8337 3.83333H14.667V2.16667C14.667 1.72464 14.4914 1.30072 14.1788 0.988155C13.8663 0.675595 13.4424 0.5 13.0003 0.5H8.00033C7.5583 0.5 7.13437 0.675595 6.82181 0.988155C6.50925 1.30072 6.33366 1.72464 6.33366 2.16667V3.83333H2.16699V5.5H3.83366V18C3.83366 18.663 4.09705 19.2989 4.56589 19.7678C5.03473 20.2366 5.67062 20.5 6.33366 20.5H14.667C15.33 20.5 15.9659 20.2366 16.4348 19.7678C16.9036 19.2989 17.167 18.663 17.167 18V5.5H18.8337V3.83333ZM8.00033 2.16667H13.0003V3.83333H8.00033V2.16667ZM15.5003 18C15.5003 18.221 15.4125 18.433 15.2562 18.5893C15.1 18.7455 14.888 18.8333 14.667 18.8333H6.33366C6.11265 18.8333 5.90068 18.7455 5.7444 18.5893C5.58812 18.433 5.50033 18.221 5.50033 18V5.5H15.5003V18Z"
                          fill="#FF7C7C"/>
                      <path d="M9.66666 8.83282H8V15.4995H9.66666V8.83282Z" fill="#FF7C7C"/>
                      <path d="M13.0007 8.83282H11.334V15.4995H13.0007V8.83282Z" fill="#FF7C7C"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1_1597">
                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span>Удалить</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="selectedUser !== -1" class="tableview-main-right">
            <div class="tableview-main-right-top">
              <div class="tableview-main-right-name">
                {{ selectedUser.username }}
              </div>
              <div class="tableview-main-right-status"
                   :class="{ 'inactive': selectedUser.status === 'ia' }"
              />
            </div>
            <div class="tableview-main-right-additional">
              <div class="tableview-main-right-additional-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M22.767 8.392L15.535 1.464C14.6 0.529225 13.3327 0.00285293 12.0106 4.18348e-05C10.6884 -0.00276926 9.419 0.518209 8.48 1.449L1.233 8.392C0.844071 8.76591 0.534448 9.21434 0.322607 9.71052C0.110766 10.2067 0.00104801 10.7405 0 11.28L0 24H24V11.28C23.999 10.7405 23.8892 10.2067 23.6774 9.71052C23.4656 9.21434 23.1559 8.76591 22.767 8.392ZM9.879 2.878C10.4522 2.32794 11.2168 2.02212 12.0112 2.02511C12.8057 2.02809 13.5679 2.33964 14.137 2.894L20.885 9.358L14.121 16.122C13.5493 16.6669 12.7898 16.9709 12 16.9709C11.2102 16.9709 10.4507 16.6669 9.879 16.122L3.115 9.358L9.879 2.878ZM22 22H2V11.28C2 11.216 2.013 11.154 2.019 11.09L8.465 17.536C9.40264 18.4734 10.6742 18.9999 12 18.9999C13.3258 18.9999 14.5974 18.4734 15.535 17.536L21.981 11.09C21.987 11.154 22 11.216 22 11.28V22Z"
                      fill="#374957"/>
                </svg>
              </div>
              <div>
                <div class="tableview-main-right-additional-label">
                  Последняя активность:
                </div>
                <div class="tableview-main-right-additional-value">
                  {{ formatDate(selectedUser.last_login_date) }}
                </div>
              </div>
            </div>
            <div class="tableview-main-right-additional">
              <div class="tableview-main-right-additional-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M12 12.0001C12.7911 12.0001 13.5645 11.7655 14.2223 11.3259C14.8801 10.8864 15.3928 10.2617 15.6955 9.5308C15.9983 8.79989 16.0775 7.99562 15.9231 7.2197C15.7688 6.44378 15.3878 5.73104 14.8284 5.17163C14.269 4.61222 13.5563 4.23126 12.7804 4.07692C12.0044 3.92258 11.2002 4.00179 10.4693 4.30454C9.73836 4.60729 9.11365 5.11998 8.67412 5.77778C8.2346 6.43558 8 7.20894 8 8.00006C8 9.06093 8.42143 10.0783 9.17157 10.8285C9.92172 11.5786 10.9391 12.0001 12 12.0001ZM12 6.00006C12.3956 6.00006 12.7822 6.11736 13.1111 6.33712C13.44 6.55688 13.6964 6.86924 13.8478 7.23469C13.9991 7.60015 14.0387 8.00228 13.9616 8.39024C13.8844 8.7782 13.6939 9.13457 13.4142 9.41427C13.1345 9.69398 12.7781 9.88446 12.3902 9.96163C12.0022 10.0388 11.6001 9.9992 11.2346 9.84782C10.8692 9.69645 10.5568 9.4401 10.3371 9.1112C10.1173 8.7823 10 8.39562 10 8.00006C10 7.46963 10.2107 6.96092 10.5858 6.58585C10.9609 6.21077 11.4696 6.00006 12 6.00006ZM16 22.0301L24 23.9781V13.4831C23.9998 12.8389 23.7923 12.212 23.4081 11.6949C23.024 11.1779 22.4836 10.7982 21.867 10.6121L19.767 9.91206C19.9206 9.28832 19.9988 8.64842 20 8.00606C20 5.88433 19.1572 3.8495 17.6569 2.34921C16.1566 0.848914 14.1217 0.00605965 12 0.00605965C9.87827 0.00605965 7.84344 0.848914 6.34315 2.34921C4.84286 3.8495 4 5.88433 4 8.00606C4.00296 8.41199 4.03639 8.81713 4.1 9.21806C3.64587 9.03701 3.15429 8.97001 2.66827 9.02291C2.18225 9.0758 1.7166 9.24699 1.31205 9.52149C0.907496 9.796 0.576373 10.1655 0.347646 10.5975C0.118919 11.0296 -0.000443211 11.5112 1.23664e-06 12.0001V21.7521L7.983 24.0331L16 22.0301ZM7.757 3.76406C8.88425 2.65281 10.4049 2.03203 11.9878 2.03694C13.5707 2.04185 15.0875 2.67205 16.2079 3.79027C17.3282 4.90849 17.9612 6.42412 17.9691 8.00699C17.977 9.58986 17.3591 11.1117 16.25 12.2411L12 16.4001L7.757 12.2491C6.63187 11.1239 5.99978 9.59779 5.99978 8.00656C5.99978 6.41533 6.63187 4.88927 7.757 3.76406ZM2 12.0001C1.99874 11.8351 2.03891 11.6725 2.11684 11.5272C2.19476 11.3818 2.30795 11.2583 2.446 11.1681C2.59041 11.0733 2.75678 11.0172 2.92911 11.0053C3.10143 10.9934 3.27392 11.026 3.43 11.1001L4.864 11.6181C5.24766 12.3778 5.74958 13.0718 6.351 13.6741L12 19.2001L17.657 13.6671C18.2133 13.1116 18.6849 12.4775 19.057 11.7851L21.274 12.5261C21.4828 12.5858 21.6665 12.7119 21.7973 12.8852C21.9281 13.0586 21.9989 13.2699 21.999 13.4871V21.4361L16 19.9701L8.02 21.9701L2 20.2461V12.0001Z"
                      fill="#374957"/>
                </svg>
              </div>
              <div>
                <div class="tableview-main-right-additional-label">
                  Последнее устройство входа:
                </div>
                <div class="tableview-main-right-additional-value">
                  {{ selectedUser.last_login_ip }}
                  {{ selectedUser.last_login_device }}
                  <p v-if="!selectedUser.last_login_ip">-</p>
                </div>
              </div>
            </div>
            <div class="tableview-main-right-divider"></div>
            <div class="singleselect-label-wrapper">
              <div class="edit-multiselect-label">Роль пользователя</div>
              <Multiselect
                  v-model="editableUser.role"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="[
                      {'value':'ROLE_ADMIN', 'label': 'Администратор'},
                      {'value':'ROLE_USER', 'label': 'Диспетчер'},
                  ]"
              />
            </div>
            <div class="singleselect-label-wrapper">
              <div class="edit-multiselect-label">Статус</div>
              <Multiselect
                  v-model="editableUser.status"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="[
                      {'value':'a', 'label': 'Активный пользователь'},
                      {'value':'ia', 'label': 'Неактивный пользователь'},
                  ]"
              />
            </div>
            <div v-if="editableUser.role === 'ROLE_USER'" class="singleselect-label-wrapper">
              <div class="edit-multiselect-label">Основной перевозчик</div>
              <Multiselect
                  v-model="editableUser.carrierId"
                  :searchable="true"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="multiselectItems"
              />
            </div>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.usernameError }"
            >
              <div class="edit-input-label">Логин пользователя</div>
              <input v-model="editableUser.username" type="text" placeholder="Введите логин пользователя">
              <div class="edit-error" v-if="editValidationErrors.usernameError">{{
                  editValidationErrors.usernameError
                }}
              </div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.emailError }"
            >
              <div class="edit-input-label">E-mail пользователя</div>
              <input v-model="editableUser.email" type="text" placeholder="Введите e-mail пользователя">
              <div class="edit-error" v-if="editValidationErrors.emailError">{{ editValidationErrors.emailError }}</div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.phoneError }"
            >
              <div class="edit-input-label">Телефон пользователя</div>
              <input
                  v-maska="'+7 (###) ###-##-##'"
                  v-model="editableUser.phone"
                  type="text"
                  placeholder="Введите телефон пользователя">
              <div class="edit-error" v-if="editValidationErrors.phoneError">{{
                  editValidationErrors.phoneError
                }}
              </div>
            </label>
            <div v-if="editableUser.role === 'ROLE_USER'" class="multiselect-label-wrapper">
              <div class="edit-multiselect-label">Доступ к перевозчикам</div>
              <Multiselect
                  v-model="editableUser.access_carriers"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  noResultsText="Результаты не найдены"
                  :options="multiselectItems.filter(item => item.value !== editableUser.carrierId)"
              />
            </div>

            <!-- права администратора-->
            <div
                v-if="editableUser.role === 'ROLE_ADMIN'"
                class="user-permission"
                :class="{ 'pointers-inactive': $store.state.user.id === editableUser.id }"
            >
              <div class="user-permission-title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"
                      fill="#374957"/>
                  <path
                      d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"
                      fill="#374957"/>
                  <path
                      d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"
                      fill="#374957"/>
                </svg>
                Права пользователя
              </div>
              <div class="form-check form-switch">
                <label>
                  <input :checked="editableUser.roles.includes('ROLE_ADD_ADMIN')"
                         @change="filterEditableRoles('ROLE_ADD_ADMIN')" class="form-check-input" type="checkbox"
                         role="switch">
                  Добавление новых администраторов
                </label>
              </div>
<!--              <div class="form-check form-switch">-->
<!--                <label>-->
<!--                  <input :checked="editableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                         @change="filterEditableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                         role="switch">-->
<!--                  Удаление объектов в системе-->
<!--                </label>-->
<!--              </div>-->
              <div class="form-check form-switch">
                <label>
                  <input :checked="editableUser.roles.includes('ROLE_CONFIG')"
                         @change="filterEditableRoles('ROLE_CONFIG')" class="form-check-input" type="checkbox"
                         role="switch">
                  Доступ в раздел конфигурации системы
                </label>
              </div>
              <div class="form-check form-switch">
                <label>
                  <input :checked="editableUser.roles.includes('ROLE_CARRIERS')"
                         @change="filterEditableRoles('ROLE_CARRIERS')" class="form-check-input" type="checkbox"
                         role="switch">
                  Управление справочником перевозчиков
                </label>
              </div>
            </div>

            <!-- права диспетчера-->
<!--            <div-->
<!--                v-if="editableUser.role === 'ROLE_USER'"-->
<!--                class="user-permission"-->
<!--                :class="{ 'pointers-inactive': $store.state.user.id === editableUser.id }"-->
<!--            >-->
<!--              <div class="user-permission-title">-->
<!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path-->
<!--                      d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"-->
<!--                      fill="#374957"/>-->
<!--                  <path-->
<!--                      d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"-->
<!--                      fill="#374957"/>-->
<!--                  <path-->
<!--                      d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"-->
<!--                      fill="#374957"/>-->
<!--                </svg>-->
<!--                Права пользователя-->
<!--              </div>-->
<!--              <div class="form-check form-switch">-->
<!--                <label>-->
<!--                  <input :checked="editableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                         @change="filterEditableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                         role="switch">-->
<!--                  Удаление объектов в системе-->
<!--                </label>-->
<!--              </div>-->
<!--            </div>-->

            <button @click="updateUser" class="button-update">
              Сохранить изменения
            </button>
          </div>
        </div>
        <LoadingSpinner v-else/>
      </div>
    </div>

    <!--    create user modal-->
    <ModalView
        v-model:show="createDialogVisible"
        :title="'Добавить пользователя'"
    >
      <div
          class="singleselect-label-wrapper"
          :class="{ 'pointers-inactive': !$store.state.user.roles.includes('ROLE_ADD_ADMIN') }"
      >
        <div class="edit-multiselect-label">Роль пользователя</div>
        <Multiselect
            v-model="creatableUser.role"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="$store.state.user.roles.includes('ROLE_ADD_ADMIN') ? [
                      {'value':'ROLE_ADMIN', 'label': 'Администратор'},
                      {'value':'ROLE_USER', 'label': 'Диспетчер'},
                  ] : [
                      {'value':'ROLE_USER', 'label': 'Диспетчер'},
                  ]"
        />
      </div>
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Статус</div>
        <Multiselect
            v-model="creatableUser.status"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="[
                      {'value':'a', 'label': 'Активный пользователь'},
                      {'value':'ia', 'label': 'Неактивный пользователь'},
                  ]"
        />
      </div>
      <div v-if="creatableUser.role === 'ROLE_USER'" class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Основной перевозчик</div>
        <Multiselect
            v-model="creatableUser.carrierId"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="multiselectItems"
        />
      </div>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.usernameError }"
      >
        <div class="edit-input-label">Логин пользователя</div>
        <input v-model="creatableUser.username" type="text" placeholder="Введите логин пользователя">
        <div class="edit-error" v-if="createValidationErrors.usernameError">{{
            createValidationErrors.usernameError
          }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.emailError }"
      >
        <div class="edit-input-label">E-mail пользователя</div>
        <input v-model="creatableUser.email" type="text" placeholder="Введите e-mail пользователя">
        <div class="edit-error" v-if="createValidationErrors.emailError">{{ createValidationErrors.emailError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.phoneError }"
      >
        <div class="edit-input-label">Телефон пользователя</div>
        <input
            v-maska="'+7 (###) ###-##-##'"
            v-model="creatableUser.phone"
            type="text"
            placeholder="Введите телефон пользователя">
        <div class="edit-error" v-if="createValidationErrors.phoneError">{{
            createValidationErrors.phoneError
          }}
        </div>
      </label>
      <div v-if="creatableUser.role === 'ROLE_USER'" class="multiselect-label-wrapper">
        <div class="edit-multiselect-label">Доступ к перевозчикам</div>
        <Multiselect
            v-model="creatableUser.access_carriers"
            mode="tags"
            :close-on-select="false"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :options="multiselectItems.filter(item => item.value !== creatableUser.carrierId)"
        />
      </div>

      <!-- права администратора-->
      <div v-if="creatableUser.role === 'ROLE_ADMIN'" class="user-permission">
        <div class="user-permission-title">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"
                fill="#374957"/>
            <path
                d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"
                fill="#374957"/>
            <path
                d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"
                fill="#374957"/>
          </svg>
          Права пользователя
        </div>
        <div class="form-check form-switch">
          <label>
            <input :checked="creatableUser.roles.includes('ROLE_ADD_ADMIN')"
                   @change="filterCreatableRoles('ROLE_ADD_ADMIN')" class="form-check-input" type="checkbox"
                   role="switch">
            Добавление новых администраторов
          </label>
        </div>
<!--        <div class="form-check form-switch">-->
<!--          <label>-->
<!--            <input :checked="creatableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                   @change="filterCreatableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                   role="switch">-->
<!--            Удаление объектов в системе-->
<!--          </label>-->
<!--        </div>-->
        <div class="form-check form-switch">
          <label>
            <input :checked="creatableUser.roles.includes('ROLE_CONFIG')" @change="filterCreatableRoles('ROLE_CONFIG')"
                   class="form-check-input" type="checkbox" role="switch">
            Доступ в раздел конфигурации системы
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input :checked="creatableUser.roles.includes('ROLE_CARRIERS')"
                   @change="filterCreatableRoles('ROLE_CARRIERS')" class="form-check-input" type="checkbox"
                   role="switch">
            Управление справочником перевозчиков
          </label>
        </div>
      </div>

      <!-- права диспетчера-->
<!--      <div v-if="creatableUser.role === 'ROLE_USER'" class="user-permission">-->
<!--        <div class="user-permission-title">-->
<!--          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path-->
<!--                d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"-->
<!--                fill="#374957"/>-->
<!--            <path-->
<!--                d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"-->
<!--                fill="#374957"/>-->
<!--            <path-->
<!--                d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"-->
<!--                fill="#374957"/>-->
<!--          </svg>-->
<!--          Права пользователя-->
<!--        </div>-->
<!--        <div class="form-check form-switch">-->
<!--          <label>-->
<!--            <input :checked="creatableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                   @change="filterCreatableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                   role="switch">-->
<!--            Удаление объектов в системе-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->

      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button @click="createUser" type="button" class="button-add">Добавить пользователя</button>
      </template>
    </ModalView>

    <!--    edit user modal-->
    <ModalView
        class="edit-modal"
        v-model:show="editDialogVisible"
        v-model:selectedObj="selectedUser"
        :title="'Пользователь: ' + selectedUser.username"
    >
      <div class="tableview-main-right-additional">
        <div class="tableview-main-right-additional-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.767 8.392L15.535 1.464C14.6 0.529225 13.3327 0.00285293 12.0106 4.18348e-05C10.6884 -0.00276926 9.419 0.518209 8.48 1.449L1.233 8.392C0.844071 8.76591 0.534448 9.21434 0.322607 9.71052C0.110766 10.2067 0.00104801 10.7405 0 11.28L0 24H24V11.28C23.999 10.7405 23.8892 10.2067 23.6774 9.71052C23.4656 9.21434 23.1559 8.76591 22.767 8.392ZM9.879 2.878C10.4522 2.32794 11.2168 2.02212 12.0112 2.02511C12.8057 2.02809 13.5679 2.33964 14.137 2.894L20.885 9.358L14.121 16.122C13.5493 16.6669 12.7898 16.9709 12 16.9709C11.2102 16.9709 10.4507 16.6669 9.879 16.122L3.115 9.358L9.879 2.878ZM22 22H2V11.28C2 11.216 2.013 11.154 2.019 11.09L8.465 17.536C9.40264 18.4734 10.6742 18.9999 12 18.9999C13.3258 18.9999 14.5974 18.4734 15.535 17.536L21.981 11.09C21.987 11.154 22 11.216 22 11.28V22Z"
                fill="#374957"/>
          </svg>
        </div>
        <div>
          <div class="tableview-main-right-additional-label">
            Последняя активность:
          </div>
          <div class="tableview-main-right-additional-value">
            1 мин 24 сек назад
          </div>
        </div>
      </div>
      <div class="tableview-main-right-additional">
        <div class="tableview-main-right-additional-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 12.0001C12.7911 12.0001 13.5645 11.7655 14.2223 11.3259C14.8801 10.8864 15.3928 10.2617 15.6955 9.5308C15.9983 8.79989 16.0775 7.99562 15.9231 7.2197C15.7688 6.44378 15.3878 5.73104 14.8284 5.17163C14.269 4.61222 13.5563 4.23126 12.7804 4.07692C12.0044 3.92258 11.2002 4.00179 10.4693 4.30454C9.73836 4.60729 9.11365 5.11998 8.67412 5.77778C8.2346 6.43558 8 7.20894 8 8.00006C8 9.06093 8.42143 10.0783 9.17157 10.8285C9.92172 11.5786 10.9391 12.0001 12 12.0001ZM12 6.00006C12.3956 6.00006 12.7822 6.11736 13.1111 6.33712C13.44 6.55688 13.6964 6.86924 13.8478 7.23469C13.9991 7.60015 14.0387 8.00228 13.9616 8.39024C13.8844 8.7782 13.6939 9.13457 13.4142 9.41427C13.1345 9.69398 12.7781 9.88446 12.3902 9.96163C12.0022 10.0388 11.6001 9.9992 11.2346 9.84782C10.8692 9.69645 10.5568 9.4401 10.3371 9.1112C10.1173 8.7823 10 8.39562 10 8.00006C10 7.46963 10.2107 6.96092 10.5858 6.58585C10.9609 6.21077 11.4696 6.00006 12 6.00006ZM16 22.0301L24 23.9781V13.4831C23.9998 12.8389 23.7923 12.212 23.4081 11.6949C23.024 11.1779 22.4836 10.7982 21.867 10.6121L19.767 9.91206C19.9206 9.28832 19.9988 8.64842 20 8.00606C20 5.88433 19.1572 3.8495 17.6569 2.34921C16.1566 0.848914 14.1217 0.00605965 12 0.00605965C9.87827 0.00605965 7.84344 0.848914 6.34315 2.34921C4.84286 3.8495 4 5.88433 4 8.00606C4.00296 8.41199 4.03639 8.81713 4.1 9.21806C3.64587 9.03701 3.15429 8.97001 2.66827 9.02291C2.18225 9.0758 1.7166 9.24699 1.31205 9.52149C0.907496 9.796 0.576373 10.1655 0.347646 10.5975C0.118919 11.0296 -0.000443211 11.5112 1.23664e-06 12.0001V21.7521L7.983 24.0331L16 22.0301ZM7.757 3.76406C8.88425 2.65281 10.4049 2.03203 11.9878 2.03694C13.5707 2.04185 15.0875 2.67205 16.2079 3.79027C17.3282 4.90849 17.9612 6.42412 17.9691 8.00699C17.977 9.58986 17.3591 11.1117 16.25 12.2411L12 16.4001L7.757 12.2491C6.63187 11.1239 5.99978 9.59779 5.99978 8.00656C5.99978 6.41533 6.63187 4.88927 7.757 3.76406ZM2 12.0001C1.99874 11.8351 2.03891 11.6725 2.11684 11.5272C2.19476 11.3818 2.30795 11.2583 2.446 11.1681C2.59041 11.0733 2.75678 11.0172 2.92911 11.0053C3.10143 10.9934 3.27392 11.026 3.43 11.1001L4.864 11.6181C5.24766 12.3778 5.74958 13.0718 6.351 13.6741L12 19.2001L17.657 13.6671C18.2133 13.1116 18.6849 12.4775 19.057 11.7851L21.274 12.5261C21.4828 12.5858 21.6665 12.7119 21.7973 12.8852C21.9281 13.0586 21.9989 13.2699 21.999 13.4871V21.4361L16 19.9701L8.02 21.9701L2 20.2461V12.0001Z"
                fill="#374957"/>
          </svg>
        </div>
        <div>
          <div class="tableview-main-right-additional-label">
            Последнее устройство входа:
          </div>
          <div class="tableview-main-right-additional-value">
            188.243.129.243
            MacBookPro - PavlenkoDarya
          </div>
        </div>
      </div>
      <div class="tableview-main-right-divider"></div>
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Роль пользователя</div>
        <Multiselect
            v-model="editableUser.role"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="[
                      {'value':'ROLE_ADMIN', 'label': 'Администратор'},
                      {'value':'ROLE_USER', 'label': 'Диспетчер'},
                  ]"
        />
      </div>
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Статус</div>
        <Multiselect
            v-model="editableUser.status"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="[
                      {'value':'a', 'label': 'Активный пользователь'},
                      {'value':'ia', 'label': 'Неактивный пользователь'},
                  ]"
        />
      </div>
      <div v-if="editableUser.role === 'ROLE_USER'" class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Основной перевозчик</div>
        <Multiselect
            v-model="editableUser.carrierId"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="multiselectItems"
        />
      </div>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.usernameError }"
      >
        <div class="edit-input-label">Логин пользователя</div>
        <input v-model="editableUser.username" type="text" placeholder="Введите логин пользователя">
        <div class="edit-error" v-if="editValidationErrors.usernameError">{{
            editValidationErrors.usernameError
          }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.emailError }"
      >
        <div class="edit-input-label">E-mail пользователя</div>
        <input v-model="editableUser.email" type="text" placeholder="Введите e-mail пользователя">
        <div class="edit-error" v-if="editValidationErrors.emailError">{{ editValidationErrors.emailError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.phoneError }"
      >
        <div class="edit-input-label">Телефон пользователя</div>
        <input
            v-maska="'+7 (###) ###-##-##'"
            v-model="editableUser.phone"
            type="text"
            placeholder="Введите телефон пользователя">
        <div class="edit-error" v-if="editValidationErrors.phoneError">{{
            editValidationErrors.phoneError
          }}
        </div>
      </label>
      <div v-if="editableUser.role === 'ROLE_USER'" class="multiselect-label-wrapper">
        <div class="edit-multiselect-label">Доступ к перевозчикам</div>
        <Multiselect
            v-model="editableUser.access_carriers"
            mode="tags"
            :close-on-select="false"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :options="multiselectItems.filter(item => item.value !== editableUser.carrierId)"
        />
      </div>

      <!-- права администратора-->
      <div
          v-if="editableUser.role === 'ROLE_ADMIN'"
          class="user-permission"
          :class="{ 'pointers-inactive': $store.state.user.id === editableUser.id }"
      >
        <div class="user-permission-title">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"
                fill="#374957"/>
            <path
                d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"
                fill="#374957"/>
            <path
                d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"
                fill="#374957"/>
          </svg>
          Права пользователя
        </div>
        <div class="form-check form-switch">
          <label>
            <input :checked="editableUser.roles.includes('ROLE_ADD_ADMIN')"
                   @change="filterEditableRoles('ROLE_ADD_ADMIN')" class="form-check-input" type="checkbox"
                   role="switch">
            Добавление новых администраторов
          </label>
        </div>
<!--        <div class="form-check form-switch">-->
<!--          <label>-->
<!--            <input :checked="editableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                   @change="filterEditableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                   role="switch">-->
<!--            Удаление объектов в системе-->
<!--          </label>-->
<!--        </div>-->
        <div class="form-check form-switch">
          <label>
            <input :checked="editableUser.roles.includes('ROLE_CONFIG')"
                   @change="filterEditableRoles('ROLE_CONFIG')" class="form-check-input" type="checkbox"
                   role="switch">
            Доступ в раздел конфигурации системы
          </label>
        </div>
        <div class="form-check form-switch">
          <label>
            <input :checked="editableUser.roles.includes('ROLE_CARRIERS')"
                   @change="filterEditableRoles('ROLE_CARRIERS')" class="form-check-input" type="checkbox"
                   role="switch">
            Управление справочником перевозчиков
          </label>
        </div>
      </div>

      <!-- права диспетчера-->
<!--      <div-->
<!--          v-if="editableUser.role === 'ROLE_USER'"-->
<!--          class="user-permission"-->
<!--          :class="{ 'pointers-inactive': $store.state.user.id === editableUser.id }"-->
<!--      >-->
<!--        <div class="user-permission-title">-->
<!--          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path-->
<!--                d="M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10024 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032Z"-->
<!--                fill="#374957"/>-->
<!--            <path-->
<!--                d="M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75Z"-->
<!--                fill="#374957"/>-->
<!--            <path-->
<!--                d="M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22Z"-->
<!--                fill="#374957"/>-->
<!--          </svg>-->
<!--          Права пользователя-->
<!--        </div>-->
<!--        <div class="form-check form-switch">-->
<!--          <label>-->
<!--            <input :checked="editableUser.roles.includes('ROLE_DELETE_OBJECT')"-->
<!--                   @change="filterEditableRoles('ROLE_DELETE_OBJECT')" class="form-check-input" type="checkbox"-->
<!--                   role="switch">-->
<!--            Удаление объектов в системе-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->

      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button @click="updateUser" type="button" class="button-add">Сохранить изменения</button>
      </template>
    </ModalView>

    <!--    data for login after create user modal-->
    <ModalView
        v-model:show="temporaryPasswordDialogVisible"
        :title="'Данные для входа'"
    >
      <div>
        E-mail: {{ emailAfterCreate }}
      </div>
      <div>
        Временный пароль: {{ temporaryPassword }}
      </div>
      <div>
        Ссылка для авторизации: {{ getAuthorizationUrl() }}
      </div>

      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button
            @click="writeClipboardText(`E-mail: ${emailAfterCreate}, временный пароль: ${temporaryPassword}, ссылка для авторизации: ${getAuthorizationUrl()}`)"
            type="button" class="button-add">Скопировать данные
        </button>
        <button @click="sendToEmail"
                type="button" class="button-add">Отправить данные на e-mail
        </button>
      </template>
    </ModalView>
  </div>
</template>

<script>

import NavigationView from "@/components/NavigationView";
import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import ModalView from "@/components/ModalView";
import Multiselect from '@vueform/multiselect'
import {toast} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Swal from "@/sweetalert2";
import FilterIcon from "@/components/icons/filter-icon.vue";
import FilterSelectedIcon from "@/components/icons/filter-selected-icon.vue";

export default {
  name: "UsersView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push('/login');
    }
    if (!store.state.user.roles.includes('ROLE_ADMIN')) {
      this.$router.push('/');
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      this.fetchUsers();
    }
    document.addEventListener('click', this.onGlobalClick, { capture: true })
  },
  unmounted() {
    document.removeEventListener('click', this.onGlobalClick, { capture: true })
  },
  data() {
    return {
      startLoading: false,
      loading: false,
      searchValue: '',
      tableHeaders: [
        {text: "Статус", value: "status", sortable: true, width: 100},
        {text: "Компания", value: "carrierName", sortable: true},
        {text: "Логин", value: "username", sortable: true},
        {text: "E-mail", value: "email", sortable: true},
        // {text: "Последний вход", value: "lastEnter", sortable: true},
        {text: "Роль в системе", value: "roleName", sortable: true},
      ],
      tableItems: [],
      multiselectItems: [],
      itemsSelected: [],
      selectedUser: -1,
      editableUser: -1,
      creatableUser: {},
      createValidationErrors: {},
      editValidationErrors: {},
      createDialogVisible: false,
      editDialogVisible: false,
      statusCriteria: 'Все',
      showStatusFilter: false,
      carrierCriteria: 'Все',
      showCarrierFilter: false,
      roleCriteria: 'Все',
      showRoleFilter: false,
      emailAfterCreate: '',
      temporaryPassword: '',
      temporaryPasswordDialogVisible: false,
      userIdForEmail: '',
    };
  },
  computed: {
    filterOptions() {
      const filterOptionsArray = [];
      if (this.statusCriteria !== 'Все') {
        filterOptionsArray.push({
          field: 'status',
          comparison: '=',
          criteria: this.statusCriteria,
        });
      }
      if (this.carrierCriteria !== 'Все') {
        filterOptionsArray.push({
          field: 'carrierName',
          comparison: '=',
          criteria: this.carrierCriteria,
        });
      }
      if (this.roleCriteria !== 'Все') {
        filterOptionsArray.push({
          field: 'roleName',
          comparison: '=',
          criteria: this.roleCriteria,
        });
      }
      return filterOptionsArray;
    }
  },
  components: {
    NavigationView,
    LoadingSpinner,
    Multiselect,
    ModalView,
    FilterIcon,
    FilterSelectedIcon,
  },
  methods: {
    closeAllFilters() {
      this.showStatusFilter = false
      this.showRoleFilter = false
      this.showCarrierFilter = false
    },
    onGlobalClick(e) {
      if (e.target.closest('.filter-menu') || e.target.closest('.filter-icon')) return
      this.closeAllFilters();
    },
    async fetchUsers() {
      try {
        this.startLoading = true;
        const responses = await Promise.all([
          http.get('/api/user/get'),
          http.get('/api/carrier/get/short')
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.tableItems = responses[0].data;
        }
        if (responses[1].data !== null && responses[1].status === 200) {
          this.multiselectItems = responses[1].data.carriers;
          this.tableItems = this.tableItems.map(item => {
            if (item.roles.includes('ROLE_ADMIN')) {
              item.role = 'ROLE_ADMIN';
              item.roleName = 'Администратор';
              item.carrierName = 'Цементум';
            } else {
              item.role = 'ROLE_USER';
              item.roleName = 'Диспетчер';
              if (item.carrierId) {
                item.carrierName = this.multiselectItems.find(elem => elem.value === item.carrierId).label;
              } else {
                item.carrierName = 'Цементум';
              }
            }
            item.lastEnter = '—';
            return item;
          })
          this.creatableUser = {
            status: 'a',
            role: 'ROLE_USER',
            carrierId: this.multiselectItems[0].value,
            roles: [],
            access_carriers: [this.multiselectItems[0].value]
          };
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    clearFilters() {
      this.searchValue = '';
      this.itemsSelected = [];
      this.selectedUser = -1;
      this.editableUser = -1;
      this.statusCriteria = 'Все';
      this.carrierCriteria = 'Все';
      this.roleCriteria = 'Все';
      this.showStatusFilter = false;
      this.showCarrierFilter = false;
      this.showRoleFilter = false;
    },
    selectUser(item) {
      this.editValidationErrors = {};
      if (this.selectedUser.id === item.id) {
        this.selectedUser = -1;
        this.editableUser = -1;
        this.editDialogVisible = false;
      } else {
        this.selectedUser = item;
        this.editableUser = JSON.parse(JSON.stringify(item));
        this.editDialogVisible = true;
      }
    },
    async updateUser() {
      this.editValidationErrors = {};
      if (!this.editableUser.username) {
        this.editValidationErrors.usernameError = 'Введите логин пользователя';
      }
      if (!this.editableUser.email) {
        this.editValidationErrors.emailError = 'Введите e-mail пользователя';
      }
      if (!this.editableUser.phone) {
        this.editValidationErrors.phoneError = 'Введите телефон пользователя';
      }
      if (Object.keys(this.editValidationErrors).length === 0) {
        var finalPhone = this.editableUser.phone.replace('+', '').replace('(', '').replace(')', '').replaceAll('-', '').replaceAll(' ', '');
        try {
          this.loading = true;
          var roles = [];
          if (this.editableUser.role === 'ROLE_ADMIN') {
            roles = [...new Set([this.editableUser.role, ...this.editableUser.roles])];
          } else {
            roles = ['ROLE_USER'];
            if (this.editableUser.roles.includes('ROLE_DELETE_OBJECT')) {
              roles.push('ROLE_DELETE_OBJECT');
            }
          }
          var data = {
            status: this.editableUser.status,
            username: this.editableUser.username,
            email: this.editableUser.email,
            phone: finalPhone,
            carrierId: this.editableUser.carrierId,
            roles: roles
          };
          var access_carriers = this.editableUser.access_carriers && [...this.editableUser.access_carriers].length > 0 ? [...new Set([...this.editableUser.access_carriers])] : [];
          if (access_carriers.includes(this.editableUser.carrierId)) {
            access_carriers = access_carriers.filter(item => item !== this.editableUser.carrierId);
          }
          if (this.editableUser.role !== 'ROLE_ADMIN') {
            data.access_carriers = access_carriers;
          }
          const response = await http.put(`/api/user/update/${this.editableUser.id}`, data);
          if (response.data !== null && response.status === 200) {
            var foundUser = this.tableItems.find(item => item.id === this.editableUser.id);
            foundUser.status = this.editableUser.status;
            foundUser.carrierId = this.editableUser.carrierId;
            foundUser.username = this.editableUser.username;
            foundUser.email = this.editableUser.email;
            foundUser.phone = finalPhone;
            foundUser.role = this.editableUser.role;
            foundUser.roles = roles;

            if (this.editableUser.role === 'ROLE_ADMIN') {
              foundUser.roleName = 'Администратор';
              foundUser.carrierName = 'Цементум';
            } else {
              foundUser.roleName = 'Диспетчер';
              foundUser.access_carriers = access_carriers;
              foundUser.carrierName = this.multiselectItems.find(elem => elem.value === this.editableUser.carrierId).label;
            }

            this.selectedUser = -1;
            this.editableUser = -1;
            this.editDialogVisible = false;
            this.itemsSelected = [];
            toast.success('Изменения сохранены успешно!', {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async createUser() {
      this.createValidationErrors = {};
      if (!this.creatableUser.username) {
        this.createValidationErrors.usernameError = 'Введите логин пользователя';
      }
      if (!this.creatableUser.email) {
        this.createValidationErrors.emailError = 'Введите e-mail пользователя';
      }
      if (!this.creatableUser.phone) {
        this.createValidationErrors.phoneError = 'Введите телефон пользователя';
      }

      if (Object.keys(this.createValidationErrors).length === 0) {
        var finalPhone = this.creatableUser.phone.replace('+', '').replace('(', '').replace(')', '').replaceAll('-', '').replaceAll(' ', '');
        try {
          this.loading = true;
          var roles = [];
          if (this.creatableUser.role === 'ROLE_ADMIN') {
            roles = [this.creatableUser.role, ...this.creatableUser.roles];
          } else {
            roles = ['ROLE_USER'];
            if (this.creatableUser.roles.includes('ROLE_DELETE_OBJECT')) {
              roles.push('ROLE_DELETE_OBJECT');
            }
          }
          var data = {
            status: this.creatableUser.status,
            username: this.creatableUser.username,
            carrierId: this.creatableUser.carrierId,
            email: this.creatableUser.email,
            phone: finalPhone,
            roles: roles
          };
          var access_carriers = this.creatableUser.access_carriers && [...this.creatableUser.access_carriers].length > 0 ? [...new Set([...this.creatableUser.access_carriers])] : [];
          if (this.creatableUser.role !== 'ROLE_ADMIN') {
            data.access_carriers = access_carriers;
          }
          const response = await http.post('/api/user/create', data);
          if (response.data !== null && response.status === 200) {
            var newUser = {
              "id": response.data.userId,
              "status": this.creatableUser.status,
              "username": this.creatableUser.username,
              "email": this.creatableUser.email,
              "phone": finalPhone,
              "role": this.creatableUser.role,
              "carrierId": this.creatableUser.carrierId,
              "roles": roles,
              "lastEnter": '—',
            };
            if (newUser.role === 'ROLE_ADMIN') {
              newUser.roleName = 'Администратор';
              newUser.carrierName = 'Цементум';
            } else {
              newUser.roleName = 'Диспетчер';
              newUser.access_carriers = access_carriers;
              newUser.carrierName = this.multiselectItems.find(elem => elem.value === this.creatableUser.carrierId).label;
            }
            this.userIdForEmail = response.data.userId;

            this.tableItems.push(newUser);
            this.createDialogVisible = false;
            this.creatableUser = {
              status: 'a',
              role: 'ROLE_USER',
              carrierId: this.multiselectItems[0].value,
              roles: [],
              access_carriers: [this.multiselectItems[0].value]
            };
            toast.success('Пользователь добавлен успешно!', {
              autoClose: 3000,
            });

            // show dialog with temp password
            this.emailAfterCreate = response.data.email;
            this.temporaryPassword = response.data.TempPassword;
            this.temporaryPasswordDialogVisible = true;
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async sendToEmail() {
      try {
        this.loading = true;
        var data = {
          tempPassword: this.temporaryPassword,
        };
        const response = await http.post(`/api/notify/temp-password/${this.userIdForEmail}`, data);
        if (response.data !== null && response.status === 200) {
          toast.success('Данные для входа успешно отправлены на e-mail!', {
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);

      if(!inputDate) return '-';

      date.setHours(date.getHours());

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds} GMT+3`;
    },
    showCreateDialog() {
      this.createDialogVisible = true;
      this.createValidationErrors = {};
    },
    async deleteMultiple() {
      var result = await Swal.fire({
        title: "Вы уверены, что хотите удалить выбранных пользователей?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FF7C7C",
        cancelButtonColor: "#005291",
        cancelButtonText: "Отмена",
        confirmButtonText: "Удалить"
      })
      if (result.isConfirmed) {
        try {
          this.loading = true;
          var itemsForDelete = this.itemsSelected.map(item => item.id);
          var data = {
            delete_elements: itemsForDelete,
          };
          const response = await http.post('/api/user/delete-multiple', data);
          if (response.data !== null && response.status === 200) {
            this.tableItems = this.tableItems.filter(item => !itemsForDelete.includes(item.id));
            this.itemsSelected = [];
            toast.success('Выбранные пользователи удалены успешно!', {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    filterCreatableRoles(role) {
      if (this.creatableUser.roles.includes(role)) {
        this.creatableUser.roles = this.creatableUser.roles.filter(item => item !== role);
      } else {
        this.creatableUser.roles.push(role);
      }
    },
    filterEditableRoles(role) {
      if (this.editableUser.roles.includes(role)) {
        this.editableUser.roles = this.editableUser.roles.filter(item => item !== role);
      } else {
        this.editableUser.roles.push(role);
      }
    },
    async writeClipboardText(text) {
      try {
        await navigator.clipboard.writeText(text);
        toast.success('Данные для входа скопированы успешно!', {
          autoClose: 3000,
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    getAuthorizationUrl() {
      const host = window.location.origin;
      return `${host}/login`;
    }
  }
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}

.tableview-block {
  background: #FFFFFF;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0 5px 10px #aaacbd;
}

.tableview-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}

.tableview-top-left {
  display: flex;
  align-items: center;
}

.tableview-top-count {
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
  margin-right: 20px;
}

.tableview-top-search.mobile {
  display: none;
}

.tableview-top-search label {
  position: relative;
  display: flex;
}

.tableview-top-search label input {
  background-color: #ffffff;
  box-shadow: 0px 0px 10px #dde5ed;
  border: 0;
  outline: none;
  border-radius: 10px;
  width: 350px;
  height: 38px;
  padding: 10px 42px 10px 48px;
  font-size: 14px;
  font-family: OpenSansRegular, sans-serif;
  color: #4D5460;
}

.tableview-top-search label input::placeholder {
  color: #4D5460;
}

.tableview-top-search-icon {
  position: absolute;
  top: 11px;
  left: 13px;
  pointer-events: none;
}

.tableview-top-search-close {
  position: absolute;
  background: transparent;
  border: 0;
  outline: none;
  top: 8px;
  right: 9px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tableview-top-search-close svg {
  fill: #4D5460;
}

.clear-filters {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters.mobile, .button-add-transparent.mobile {
  display: none;
}

.button-add-transparent {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  margin-right: 10px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters:active, .download-btn:active, .delete-selected-btn:active, .button-add-transparent:active {
  transform: scale(0.95);
}

.download-btn {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
  margin-right: 10px;
}

.download-btn .mobile {
  display: none;
}

.download-btn svg {
  margin-right: 8px;
}

.delete-selected-btn {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.delete-selected-btn svg {
  margin-right: 8px;
}

.tableview-main {
  display: flex;
  height: calc(100% - 68px);
}

.tableview-main-left {
  width: 100%;
  height: calc(100% - 122px);
}

.tableview-main-left.not-selected {
  height: calc(100% - 64px);
}

.tableview-main-selected {
  display: flex;
  align-items: center;
  margin-top: 43px;
  justify-content: space-between;
  padding: 20px 20px 20px 30px;
}

.tableview-main-selected-left {
  font-size: 14px;
  color: #4D5460;
}

.tableview-main-selected-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableview-main-selected-actions-text {
  font-size: 14px;
  color: #4D5460;
  margin-right: 12px;
}

.status-point-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
}

.status-point {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #418FDE;
}

.status-point.inactive {
  background: #C1C6C8;
}

.selected-field.selected {
  background: #DDE5ED;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
}

.tableview-main-right {
  background: #DDE5ED;
  padding: 17px 20px 20px 20px;
  max-width: 420px;
  /*border-radius: 0 0 10px 0;*/
  overflow: auto;
}

.tableview-main-right-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.tableview-main-right-name {
  font-family: OpenSansBold, sans-serif;
  font-size: 20px;
  color: #005291;
  margin-right: 15px;
}

.tableview-main-right-status {
  width: 18px;
  height: 18px;
  margin-left: auto;
  flex-shrink: 0;
  border-radius: 50%;
  background: #418FDE;
}

.tableview-main-right-status.inactive {
  background: #C1C6C8;
}

.tableview-main-right-info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.tableview-main-right-gos {
  font-size: 14px;
  color: #4D5460;
  margin-right: 10px;
}

.tableview-main-right-speed {
  background: #363636;
  border-radius: 10px;
  font-size: 14px;
  color: #ffffff;
  padding: 1px 10px;
}

.tableview-main-right-additional {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.tableview-main-right-additional-icon {
  margin-right: 10px;
}

.tableview-main-right-additional-label {
  margin-bottom: 3px;
  font-size: 12px;
  color: #9A9A9A;
}

.tableview-main-right-additional-value {
  font-size: 14px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #4D5460;
}

.tableview-main-right-divider {
  height: 1px;
  background: #C1C6C8;
  margin-top: 15px;
  margin-bottom: 20px;
}

.button-update {
  border-radius: 10px;
  color: #FFFFFF;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: #005291;
  width: 100%;
  height: 38px;
  outline: none;
  border: 0;
  padding: 0 12px;
  cursor: pointer;
  transition: all .4s;
}

.button-update:active {
  transform: scale(0.95);
}

.button-add {
  width: 100%;
  height: 38px;
  background: #005291;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  transition: all .4s;
}

.button-add:active {
  transform: scale(0.95);
}

.filter-column {
  display: flex;
  align-items: center;
  position: relative;
  font-family: OpenSansBold, sans-serif;
}

.filter-column svg {
  fill: #4D5460;
}

.filter-column.selected svg {
  fill: #005291;
}

.filter-icon {
  background: transparent;
  border: 0;
  outline: none;
  margin-right: 5px;
  cursor: pointer;
}

.filter-menu {
  position: absolute;
  width: 250px;
  top: 40px;
  left: 0;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 0px 10px #dde5ed;
}

.user-permission-title {
  display: flex;
  align-items: center;
  font-family: OpenSansBold, sans-serif;
  font-size: 16px;
  color: #374957;
  margin-bottom: 15px;
}

.user-permission-title svg {
  margin-right: 10px;
}

.form-switch {
  margin-bottom: 10px;
  padding-left: 33px;
}

.form-switch label {
  display: flex;
  align-items: center;
  color: #4D5460;
  font-size: 14px;
  cursor: pointer;
}

.form-switch .form-check-input {
  width: 40px;
  height: 20px;
  margin-right: 12px;
  --bs-form-check-bg: #C1C6C8;
  cursor: pointer;
}

.form-switch .form-check-input:checked {
  background-color: #005291;
  border-color: #005291;
}

.edit-modal {
  display: none;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .tableview-main-right {
    display: none;
  }

  .edit-modal {
    display: initial;
  }

  .tableview-top-search label input {
    width: 300px;
  }
}

/* < 960 */
@media screen and (max-width: 959px) {

  /*верхняя строка*/
  .tableview-top-search.pc {
    display: none;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 20px 15px 20px;
  }

  .tableview-top-search label input {
    width: 100%;
  }

  /*таблица*/
  .tableview-main {
    display: flex;
    height: calc(100% - 121px);
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .tableview-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 15px 15px 15px;
  }

  .tableview-main-selected-actions-text {
    display: none;
  }

  .tableview-main-selected {
    padding: 20px 15px 20px 15px;
  }
}

/* < 620 */
@media screen and (max-width: 619px) {
  .tableview-top-count {
    font-size: 16px;
    margin-right: 0;
  }

  .button-add-transparent.mobile, .clear-filters.mobile {
    display: initial;
    padding: 0;
    width: 38px;
    height: 38px;
  }

  .button-add-transparent.mobile {
    border: 1px solid rgb(40, 189, 74);
  }

  .button-add-transparent.mobile svg {
    width: 20px;
    height: 20px;
  }

  .button-add-transparent.mobile svg {
    fill: rgb(40, 189, 74);
  }

  .clear-filters.mobile svg {
    width: 24px;
    height: 24px;
  }

  .clear-filters.mobile svg, .clear-filters.mobile svg path {
    fill: #FF7C7C;
  }

  .clear-filters.pc, .button-add-transparent.pc {
    display: none;
  }

  .delete-selected-btn {
    height: 38px;
    width: 38px;
    padding: 1px;
  }

  .delete-selected-btn span {
    display: none;
  }

  .delete-selected-btn svg {
    margin-right: 0;
  }

  .download-btn .pc {
    display: none;
  }

  .download-btn .mobile {
    display: initial;
  }

  .tableview-main-selected {
    padding: 15px;
  }

  .tableview-main-left {
    height: calc(100% - 110px);
  }

  .tableview-main-left.not-selected {
    height: calc(100% - 44px);
  }
}
</style>